exports.UNAUTHORISED = 'unauthorised';
exports.AUTHORISED = 'authorised';
exports.PROSPECT = 'prospect';
exports.PENDING = 'pending';
